import {
	getAllStockLocations,
	getStockLocation,
	addStockLocation,
	updateStockLocation,
	deleteStockLocation,
	getAllUnitsOfMeasurement,
	getUnitOfMeasurement,
	addUnitOfMeasurement,
	updateUnitOfMeasurement,
	deleteUnitOfMeasurement,
	getAllConversions,
	getConversion,
	addConversion,
	updateConversion,
	deleteConversion,
	getAllTaxRates,
	getTaxRate,
	addTaxRate,
	updateTaxRate,
	deleteTaxRate,
	getAllPaymentMethods,
	getPaymentMethod,
	addPaymentMethod,
	updatePaymentMethod,
	deletePaymentMethod,
	getAllPaymentBills,
	getPaymentBill,
	addPaymentBill,
	updatePaymentBill,
	deletePaymentBill,
	getAllVoidReasons,
	getVoidReason,
	addVoidReason,
	updateVoidReason,
	deleteVoidReason,
	getAllRefundReasons,
	getRefundReason,
	addRefundReason,
	updateRefundReason,
	deleteRefundReason,
} from "../../config/config";
import { getPaymentBillErrorMessage } from "../../utils/localizedName";

import { toast } from "react-toastify";

export const API_REQUEST = "API_REQUEST";

// Stock Locations
export const GET_ALL_STOCK_LOCATIONS = "GET_ALL_STOCK_LOCATIONS";
export const GET_ALL_STOCK_LOCATIONS_SUCCESS = "GET_ALL_STOCK_LOCATIONS_SUCCESS";
export const GET_STOCK_LOCATION = "GET_STOCK_LOCATION";
export const GET_STOCK_LOCATION_SUCCESS = "GET_STOCK_LOCATION_SUCCESS";
export const ADD_STOCK_LOCATION = "ADD_STOCK_LOCATION";
export const ADD_STOCK_LOCATION_SUCCESS = "ADD_STOCK_LOCATION_SUCCESS";
export const UPDATE_STOCK_LOCATION = "UPDATE_STOCK_LOCATION";
export const UPDATE_STOCK_LOCATION_SUCCESS = "UPDATE_STOCK_LOCATION_SUCCESS";
export const DELETE_STOCK_LOCATION = "DELETE_STOCK_LOCATION";
export const DELETE_STOCK_LOCATION_SUCCESS = "DELETE_STOCK_LOCATION_SUCCESS";

// Units of Measurement
export const GET_ALL_UNITS_OF_MEASUREMENT = "GET_ALL_UNITS_OF_MEASUREMENT";
export const GET_ALL_UNITS_OF_MEASUREMENT_SUCCESS = "GET_ALL_UNITS_OF_MEASUREMENT_SUCCESS";
export const GET_UNIT_OF_MEASUREMENT = "GET_UNIT_OF_MEASUREMENT";
export const GET_UNIT_OF_MEASUREMENT_SUCCESS = "GET_UNIT_OF_MEASUREMENT_SUCCESS";
export const ADD_UNIT_OF_MEASUREMENT = "ADD_UNIT_OF_MEASUREMENT";
export const ADD_UNIT_OF_MEASUREMENT_SUCCESS = "ADD_UNIT_OF_MEASUREMENT_SUCCESS";
export const UPDATE_UNIT_OF_MEASUREMENT = "UPDATE_UNIT_OF_MEASUREMENT";
export const UPDATE_UNIT_OF_MEASUREMENT_SUCCESS = "UPDATE_UNIT_OF_MEASUREMENT_SUCCESS";
export const DELETE_UNIT_OF_MEASUREMENT = "DELETE_UNIT_OF_MEASUREMENT";
export const DELETE_UNIT_OF_MEASUREMENT_SUCCESS = "DELETE_UNIT_OF_MEASUREMENT_SUCCESS";

// Conversions
export const GET_ALL_CONVERSIONS = "GET_ALL_CONVERSIONS";
export const GET_ALL_CONVERSIONS_SUCCESS = "GET_ALL_CONVERSIONS_SUCCESS";
export const GET_CONVERSION = "GET_CONVERSION";
export const GET_CONVERSION_SUCCESS = "GET_CONVERSION_SUCCESS";
export const ADD_CONVERSION = "ADD_CONVERSION";
export const ADD_CONVERSION_SUCCESS = "ADD_CONVERSION_SUCCESS";
export const UPDATE_CONVERSION = "UPDATE_CONVERSION";
export const UPDATE_CONVERSION_SUCCESS = "UPDATE_CONVERSION_SUCCESS";
export const DELETE_CONVERSION = "DELETE_CONVERSION";
export const DELETE_CONVERSION_SUCCESS = "DELETE_CONVERSION_SUCCESS";

// Tax Rates
export const GET_ALL_TAX_RATES = "GET_ALL_TAX_RATES";
export const GET_ALL_TAX_RATES_SUCCESS = "GET_ALL_TAX_RATES_SUCCESS";
export const GET_TAX_RATE = "GET_TAX_RATE";
export const GET_TAX_RATE_SUCCESS = "GET_TAX_RATE_SUCCESS";
export const ADD_TAX_RATE = "ADD_TAX_RATE";
export const ADD_TAX_RATE_SUCCESS = "ADD_TAX_RATE_SUCCESS";
export const UPDATE_TAX_RATE = "UPDATE_TAX_RATE";
export const UPDATE_TAX_RATE_SUCCESS = "UPDATE_TAX_RATE_SUCCESS";
export const DELETE_TAX_RATE = "DELETE_TAX_RATE";
export const DELETE_TAX_RATE_SUCCESS = "DELETE_TAX_RATE_SUCCESS";

// Payment Methods
export const GET_ALL_PAYMENT_METHODS = "GET_ALL_PAYMENT_METHODS";
export const GET_ALL_PAYMENT_METHODS_SUCCESS = "GET_ALL_PAYMENT_METHODS_SUCCESS";
export const GET_PAYMENT_METHOD = "GET_PAYMENT_METHOD";
export const GET_PAYMENT_METHOD_SUCCESS = "GET_PAYMENT_METHOD_SUCCESS";
export const ADD_PAYMENT_METHOD = "ADD_PAYMENT_METHOD";
export const ADD_PAYMENT_METHOD_SUCCESS = "ADD_PAYMENT_METHOD_SUCCESS";
export const UPDATE_PAYMENT_METHOD = "UPDATE_PAYMENT_METHOD";
export const UPDATE_PAYMENT_METHOD_SUCCESS = "UPDATE_PAYMENT_METHOD_SUCCESS";
export const DELETE_PAYMENT_METHOD = "DELETE_PAYMENT_METHOD";
export const DELETE_PAYMENT_METHOD_SUCCESS = "DELETE_PAYMENT_METHOD_SUCCESS";

// Payment Bills
export const GET_ALL_PAYMENT_BILLS = "GET_ALL_PAYMENT_BILLS";
export const GET_ALL_PAYMENT_BILLS_SUCCESS = "GET_ALL_PAYMENT_BILLS_SUCCESS";
export const GET_PAYMENT_BILL = "GET_PAYMENT_BILL";
export const GET_PAYMENT_BILL_SUCCESS = "GET_PAYMENT_BILL_SUCCESS";
export const ADD_PAYMENT_BILL = "ADD_PAYMENT_BILL";
export const ADD_PAYMENT_BILL_SUCCESS = "ADD_PAYMENT_BILL_SUCCESS";
export const UPDATE_PAYMENT_BILL = "UPDATE_PAYMENT_BILL";
export const UPDATE_PAYMENT_BILL_SUCCESS = "UPDATE_PAYMENT_BILL_SUCCESS";
export const DELETE_PAYMENT_BILL = "DELETE_PAYMENT_BILL";
export const DELETE_PAYMENT_BILL_SUCCESS = "DELETE_PAYMENT_BILL_SUCCESS";

// Void Reasons
export const GET_ALL_VOID_REASONS = "GET_ALL_VOID_REASONS";
export const GET_ALL_VOID_REASONS_SUCCESS = "GET_ALL_VOID_REASONS_SUCCESS";
export const GET_VOID_REASON = "GET_VOID_REASON";
export const GET_VOID_REASON_SUCCESS = "GET_VOID_REASON_SUCCESS";
export const ADD_VOID_REASON = "ADD_VOID_REASON";
export const ADD_VOID_REASON_SUCCESS = "ADD_VOID_REASON_SUCCESS";
export const UPDATE_VOID_REASON = "UPDATE_VOID_REASON";
export const UPDATE_VOID_REASON_SUCCESS = "UPDATE_VOID_REASON_SUCCESS";
export const DELETE_VOID_REASON = "DELETE_VOID_REASON";
export const DELETE_VOID_REASON_SUCCESS = "DELETE_VOID_REASON_SUCCESS";

// Refund Reasons
export const GET_ALL_REFUND_REASONS = "GET_ALL_REFUND_REASONS";
export const GET_ALL_REFUND_REASONS_SUCCESS = "GET_ALL_REFUND_REASONS_SUCCESS";
export const GET_REFUND_REASON = "GET_REFUND_REASON";
export const GET_REFUND_REASON_SUCCESS = "GET_REFUND_REASON_SUCCESS";
export const ADD_REFUND_REASON = "ADD_REFUND_REASON";
export const ADD_REFUND_REASON_SUCCESS = "ADD_REFUND_REASON_SUCCESS";
export const UPDATE_REFUND_REASON = "UPDATE_REFUND_REASON";
export const UPDATE_REFUND_REASON_SUCCESS = "UPDATE_REFUND_REASON_SUCCESS";
export const DELETE_REFUND_REASON = "DELETE_REFUND_REASON";
export const DELETE_REFUND_REASON_SUCCESS = "DELETE_REFUND_REASON_SUCCESS";

const actions = {
	// Stock Locations
	getAllStockLocations: () => (dispatch) => {
		dispatch({
			type: GET_ALL_STOCK_LOCATIONS,
			payload: {
				getAllStockLocationsLoading: true,
			},
		});
		getAllStockLocations().then((res) => {
			dispatch({
				type: GET_ALL_STOCK_LOCATIONS,
				payload: {
					getAllStockLocationsLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: GET_ALL_STOCK_LOCATIONS_SUCCESS,
					payload: {
						stockLocations: res?.data?.stockLocations || [],
					},
				});
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else {
				toast.error(res?.data?.message || "Error loading stock locations", { theme: "colored" });
			}
		});
	},

	getStockLocation: (uuid) => (dispatch) => {
		dispatch({
			type: GET_STOCK_LOCATION,
			payload: {
				getStockLocationLoading: true,
			},
		});
		getStockLocation(uuid).then((res) => {
			dispatch({
				type: GET_STOCK_LOCATION,
				payload: {
					getStockLocationLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: GET_STOCK_LOCATION_SUCCESS,
					payload: {
						stockLocation: res?.data?.stockLocation,
					},
				});
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else {
				toast.error(res?.data?.message || "Error loading stock location", { theme: "colored" });
			}
		});
	},

	addStockLocation: (data) => (dispatch) => {
		dispatch({
			type: ADD_STOCK_LOCATION,
			payload: {
				addStockLocationLoading: true,
			},
		});
		return addStockLocation(data).then((res) => {
			dispatch({
				type: ADD_STOCK_LOCATION,
				payload: {
					addStockLocationLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: ADD_STOCK_LOCATION_SUCCESS,
					payload: {
						stockLocations: res?.data?.stockLocations || [],
					},
				});
				toast.success(res?.data?.message || "Stock location added successfully", { theme: "colored" });
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else if (res?.status === 501) {
				toast.error(res?.data?.message || "Code already exists", { theme: "colored" });
			} else {
				toast.error(res?.data?.message || "Error adding stock location", { theme: "colored" });
			}
			return res;
		});
	},

	updateStockLocation: (data, uuid) => (dispatch) => {
		dispatch({
			type: UPDATE_STOCK_LOCATION,
			payload: {
				updateStockLocationLoading: true,
			},
		});
		return updateStockLocation(data, uuid).then((res) => {
			dispatch({
				type: UPDATE_STOCK_LOCATION,
				payload: {
					updateStockLocationLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: UPDATE_STOCK_LOCATION_SUCCESS,
					payload: {
						stockLocations: res?.data?.stockLocations || [],
					},
				});
				toast.success(res?.data?.message || "Stock location updated successfully", { theme: "colored" });
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else if (res?.status === 501) {
				toast.error(res?.data?.message || "Stock location not found or code already exists", { theme: "colored" });
			} else {
				toast.error(res?.data?.message || "Error updating stock location", { theme: "colored" });
			}
			return res;
		});
	},

	deleteStockLocation: (uuid) => (dispatch) => {
		dispatch({
			type: DELETE_STOCK_LOCATION,
			payload: {
				deleteStockLocationLoading: true,
			},
		});
		deleteStockLocation(uuid).then((res) => {
			dispatch({
				type: DELETE_STOCK_LOCATION,
				payload: {
					deleteStockLocationLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: DELETE_STOCK_LOCATION_SUCCESS,
					payload: {
						stockLocations: res?.data?.stockLocations || [],
					},
				});
				toast.success(res?.data?.message || "Stock location deleted successfully", { theme: "colored" });
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else if (res?.status === 501) {
				toast.error(res?.data?.message || "Stock location not found", { theme: "colored" });
			} else {
				toast.error(res?.data?.message || "Error deleting stock location", { theme: "colored" });
			}
		});
	},

	// Units of Measurement
	getAllUnitsOfMeasurement: () => (dispatch) => {
		dispatch({
			type: GET_ALL_UNITS_OF_MEASUREMENT,
			payload: {
				getAllUnitsOfMeasurementLoading: true,
			},
		});
		getAllUnitsOfMeasurement().then((res) => {
			dispatch({
				type: GET_ALL_UNITS_OF_MEASUREMENT,
				payload: {
					getAllUnitsOfMeasurementLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: GET_ALL_UNITS_OF_MEASUREMENT_SUCCESS,
					payload: {
						unitsOfMeasurement: res?.data?.unitsOfMeasurement || [],
					},
				});
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else {
				toast.error(res?.data?.message || "Error loading units of measurement", { theme: "colored" });
			}
		});
	},

	getUnitOfMeasurement: (uuid) => (dispatch) => {
		dispatch({
			type: GET_UNIT_OF_MEASUREMENT,
			payload: {
				getUnitOfMeasurementLoading: true,
			},
		});
		getUnitOfMeasurement(uuid).then((res) => {
			dispatch({
				type: GET_UNIT_OF_MEASUREMENT,
				payload: {
					getUnitOfMeasurementLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: GET_UNIT_OF_MEASUREMENT_SUCCESS,
					payload: {
						unitOfMeasurement: res?.data?.unitOfMeasurement,
					},
				});
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else {
				toast.error(res?.data?.message || "Error loading unit of measurement", { theme: "colored" });
			}
		});
	},

	addUnitOfMeasurement: (data) => (dispatch) => {
		dispatch({
			type: ADD_UNIT_OF_MEASUREMENT,
			payload: {
				addUnitOfMeasurementLoading: true,
			},
		});
		return addUnitOfMeasurement(data).then((res) => {
			dispatch({
				type: ADD_UNIT_OF_MEASUREMENT,
				payload: {
					addUnitOfMeasurementLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: ADD_UNIT_OF_MEASUREMENT_SUCCESS,
					payload: {
						unitsOfMeasurement: res?.data?.unitsOfMeasurement || [],
					},
				});
				toast.success(res?.data?.message || "Unit of measurement added successfully", { theme: "colored" });
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else if (res?.status === 501) {
				toast.error(res?.data?.message || "Abbreviation already exists", { theme: "colored" });
			} else {
				toast.error(res?.data?.message || "Error adding unit of measurement", { theme: "colored" });
			}
			return res;
		});
	},

	updateUnitOfMeasurement: (data, uuid) => (dispatch) => {
		dispatch({
			type: UPDATE_UNIT_OF_MEASUREMENT,
			payload: {
				updateUnitOfMeasurementLoading: true,
			},
		});
		return updateUnitOfMeasurement(data, uuid).then((res) => {
			dispatch({
				type: UPDATE_UNIT_OF_MEASUREMENT,
				payload: {
					updateUnitOfMeasurementLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: UPDATE_UNIT_OF_MEASUREMENT_SUCCESS,
					payload: {
						unitsOfMeasurement: res?.data?.unitsOfMeasurement || [],
					},
				});
				toast.success(res?.data?.message || "Unit of measurement updated successfully", { theme: "colored" });
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else if (res?.status === 501) {
				toast.error(res?.data?.message || "Unit not found or abbreviation already exists", { theme: "colored" });
			} else {
				toast.error(res?.data?.message || "Error updating unit of measurement", { theme: "colored" });
			}
			return res;
		});
	},

	deleteUnitOfMeasurement: (uuid) => (dispatch) => {
		dispatch({
			type: DELETE_UNIT_OF_MEASUREMENT,
			payload: {
				deleteUnitOfMeasurementLoading: true,
			},
		});
		deleteUnitOfMeasurement(uuid).then((res) => {
			dispatch({
				type: DELETE_UNIT_OF_MEASUREMENT,
				payload: {
					deleteUnitOfMeasurementLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: DELETE_UNIT_OF_MEASUREMENT_SUCCESS,
					payload: {
						unitsOfMeasurement: res?.data?.unitsOfMeasurement || [],
					},
				});
				toast.success(res?.data?.message || "Unit of measurement deleted successfully", { theme: "colored" });
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else if (res?.status === 501) {
				toast.error(res?.data?.message || "Unit not found", { theme: "colored" });
			} else {
				toast.error(res?.data?.message || "Error deleting unit of measurement", { theme: "colored" });
			}
		});
	},

	// Conversions
	getAllConversions: () => (dispatch) => {
		dispatch({
			type: GET_ALL_CONVERSIONS,
			payload: {
				getAllConversionsLoading: true,
			},
		});
		getAllConversions().then((res) => {
			dispatch({
				type: GET_ALL_CONVERSIONS,
				payload: {
					getAllConversionsLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: GET_ALL_CONVERSIONS_SUCCESS,
					payload: {
						conversions: res?.data?.conversions || [],
					},
				});
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else {
				toast.error(res?.data?.message || "Error loading conversions", { theme: "colored" });
			}
		});
	},

	getConversion: (uuid) => (dispatch) => {
		dispatch({
			type: GET_CONVERSION,
			payload: {
				getConversionLoading: true,
			},
		});
		getConversion(uuid).then((res) => {
			dispatch({
				type: GET_CONVERSION,
				payload: {
					getConversionLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: GET_CONVERSION_SUCCESS,
					payload: {
						conversion: res?.data?.conversion,
					},
				});
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else {
				toast.error(res?.data?.message || "Error loading conversion", { theme: "colored" });
			}
		});
	},

	addConversion: (data) => (dispatch) => {
		dispatch({
			type: ADD_CONVERSION,
			payload: {
				addConversionLoading: true,
			},
		});
		return addConversion(data).then((res) => {
			dispatch({
				type: ADD_CONVERSION,
				payload: {
					addConversionLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: ADD_CONVERSION_SUCCESS,
					payload: {
						conversions: res?.data?.conversions || [],
					},
				});
				toast.success(res?.data?.message || "Conversion added successfully", { theme: "colored" });
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else if (res?.status === 501) {
				toast.error(res?.data?.message || "Conversion already exists or units cannot be the same", { theme: "colored" });
			} else {
				toast.error(res?.data?.message || "Error adding conversion", { theme: "colored" });
			}
			return res;
		});
	},

	updateConversion: (data, uuid) => (dispatch) => {
		dispatch({
			type: UPDATE_CONVERSION,
			payload: {
				updateConversionLoading: true,
			},
		});
		return updateConversion(data, uuid).then((res) => {
			dispatch({
				type: UPDATE_CONVERSION,
				payload: {
					updateConversionLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: UPDATE_CONVERSION_SUCCESS,
					payload: {
						conversions: res?.data?.conversions || [],
					},
				});
				toast.success(res?.data?.message || "Conversion updated successfully", { theme: "colored" });
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else if (res?.status === 501) {
				toast.error(res?.data?.message || "Conversion not found or already exists", { theme: "colored" });
			} else {
				toast.error(res?.data?.message || "Error updating conversion", { theme: "colored" });
			}
			return res;
		});
	},

	deleteConversion: (uuid) => (dispatch) => {
		dispatch({
			type: DELETE_CONVERSION,
			payload: {
				deleteConversionLoading: true,
			},
		});
		deleteConversion(uuid).then((res) => {
			dispatch({
				type: DELETE_CONVERSION,
				payload: {
					deleteConversionLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: DELETE_CONVERSION_SUCCESS,
					payload: {
						conversions: res?.data?.conversions || [],
					},
				});
				toast.success(res?.data?.message || "Conversion deleted successfully", { theme: "colored" });
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else if (res?.status === 501) {
				toast.error(res?.data?.message || "Conversion not found", { theme: "colored" });
			} else {
				toast.error(res?.data?.message || "Error deleting conversion", { theme: "colored" });
			}
		});
	},

	// Tax Rates
	getAllTaxRates: () => (dispatch) => {
		dispatch({
			type: GET_ALL_TAX_RATES,
			payload: {
				getAllTaxRatesLoading: true,
			},
		});
		getAllTaxRates().then((res) => {
			dispatch({
				type: GET_ALL_TAX_RATES,
				payload: {
					getAllTaxRatesLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: GET_ALL_TAX_RATES_SUCCESS,
					payload: {
						taxRates: res?.data?.taxRates || [],
					},
				});
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else {
				toast.error(res?.data?.message || "Error loading tax rates", { theme: "colored" });
			}
		});
	},

	getTaxRate: (uuid) => (dispatch) => {
		dispatch({
			type: GET_TAX_RATE,
			payload: {
				getTaxRateLoading: true,
			},
		});
		getTaxRate(uuid).then((res) => {
			dispatch({
				type: GET_TAX_RATE,
				payload: {
					getTaxRateLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: GET_TAX_RATE_SUCCESS,
					payload: {
						taxRate: res?.data?.taxRate,
					},
				});
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else {
				toast.error(res?.data?.message || "Error loading tax rate", { theme: "colored" });
			}
		});
	},

	addTaxRate: (data) => (dispatch) => {
		dispatch({
			type: ADD_TAX_RATE,
			payload: {
				addTaxRateLoading: true,
			},
		});
		return addTaxRate(data).then((res) => {
			dispatch({
				type: ADD_TAX_RATE,
				payload: {
					addTaxRateLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: ADD_TAX_RATE_SUCCESS,
					payload: {
						taxRates: res?.data?.taxRates || [],
					},
				});
				toast.success(res?.data?.message || "Tax rate added successfully", { theme: "colored" });
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else if (res?.status === 501) {
				toast.error(res?.data?.message || "Tax rate name already exists", { theme: "colored" });
			} else {
				toast.error(res?.data?.message || "Error adding tax rate", { theme: "colored" });
			}
			return res;
		});
	},

	updateTaxRate: (data, uuid) => (dispatch) => {
		dispatch({
			type: UPDATE_TAX_RATE,
			payload: {
				updateTaxRateLoading: true,
			},
		});
		return updateTaxRate(data, uuid).then((res) => {
			dispatch({
				type: UPDATE_TAX_RATE,
				payload: {
					updateTaxRateLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: UPDATE_TAX_RATE_SUCCESS,
					payload: {
						taxRates: res?.data?.taxRates || [],
					},
				});
				toast.success(res?.data?.message || "Tax rate updated successfully", { theme: "colored" });
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else if (res?.status === 501) {
				toast.error(res?.data?.message || "Tax rate not found or name already exists", { theme: "colored" });
			} else {
				toast.error(res?.data?.message || "Error updating tax rate", { theme: "colored" });
			}
			return res;
		});
	},

	deleteTaxRate: (uuid) => (dispatch) => {
		dispatch({
			type: DELETE_TAX_RATE,
			payload: {
				deleteTaxRateLoading: true,
			},
		});
		deleteTaxRate(uuid).then((res) => {
			dispatch({
				type: DELETE_TAX_RATE,
				payload: {
					deleteTaxRateLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: DELETE_TAX_RATE_SUCCESS,
					payload: {
						taxRates: res?.data?.taxRates || [],
					},
				});
				toast.success(res?.data?.message || "Tax rate deleted successfully", { theme: "colored" });
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else if (res?.status === 501) {
				toast.error(res?.data?.message || "Tax rate not found", { theme: "colored" });
			} else {
				toast.error(res?.data?.message || "Error deleting tax rate", { theme: "colored" });
			}
		});
	},

	// Payment Methods
	getAllPaymentMethods: () => (dispatch) => {
		dispatch({
			type: GET_ALL_PAYMENT_METHODS,
			payload: {
				getAllPaymentMethodsLoading: true,
			},
		});
		getAllPaymentMethods().then((res) => {
			dispatch({
				type: GET_ALL_PAYMENT_METHODS,
				payload: {
					getAllPaymentMethodsLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: GET_ALL_PAYMENT_METHODS_SUCCESS,
					payload: {
						paymentMethods: res?.data?.paymentMethods || [],
					},
				});
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else {
				toast.error(res?.data?.message || "Error loading payment methods", { theme: "colored" });
			}
		});
	},

	getPaymentMethod: (uuid) => (dispatch) => {
		dispatch({
			type: GET_PAYMENT_METHOD,
			payload: {
				getPaymentMethodLoading: true,
			},
		});
		getPaymentMethod(uuid).then((res) => {
			dispatch({
				type: GET_PAYMENT_METHOD,
				payload: {
					getPaymentMethodLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: GET_PAYMENT_METHOD_SUCCESS,
					payload: {
						paymentMethod: res?.data?.paymentMethod,
					},
				});
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else {
				toast.error(res?.data?.message || "Error loading payment method", { theme: "colored" });
			}
		});
	},

	addPaymentMethod: (data) => (dispatch) => {
		dispatch({
			type: ADD_PAYMENT_METHOD,
			payload: {
				addPaymentMethodLoading: true,
			},
		});
		return addPaymentMethod(data).then((res) => {
			dispatch({
				type: ADD_PAYMENT_METHOD,
				payload: {
					addPaymentMethodLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: ADD_PAYMENT_METHOD_SUCCESS,
					payload: {
						paymentMethods: res?.data?.paymentMethods || [],
					},
				});
				toast.success(res?.data?.message || "Payment method added successfully", { theme: "colored" });
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else if (res?.status === 501) {
				toast.error(res?.data?.message || "Payment method name already exists", { theme: "colored" });
			} else {
				toast.error(res?.data?.message || "Error adding payment method", { theme: "colored" });
			}
			return res;
		});
	},

	updatePaymentMethod: (data, uuid) => (dispatch) => {
		dispatch({
			type: UPDATE_PAYMENT_METHOD,
			payload: {
				updatePaymentMethodLoading: true,
			},
		});
		return updatePaymentMethod(data, uuid).then((res) => {
			dispatch({
				type: UPDATE_PAYMENT_METHOD,
				payload: {
					updatePaymentMethodLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: UPDATE_PAYMENT_METHOD_SUCCESS,
					payload: {
						paymentMethods: res?.data?.paymentMethods || [],
					},
				});
				toast.success(res?.data?.message || "Payment method updated successfully", { theme: "colored" });
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else if (res?.status === 501) {
				toast.error(res?.data?.message || "Payment method not found or name already exists", { theme: "colored" });
			} else {
				toast.error(res?.data?.message || "Error updating payment method", { theme: "colored" });
			}
			return res;
		});
	},

	deletePaymentMethod: (uuid) => (dispatch) => {
		dispatch({
			type: DELETE_PAYMENT_METHOD,
			payload: {
				deletePaymentMethodLoading: true,
			},
		});
		deletePaymentMethod(uuid).then((res) => {
			dispatch({
				type: DELETE_PAYMENT_METHOD,
				payload: {
					deletePaymentMethodLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: DELETE_PAYMENT_METHOD_SUCCESS,
					payload: {
						paymentMethods: res?.data?.paymentMethods || [],
					},
				});
				toast.success(res?.data?.message || "Payment method deleted successfully", { theme: "colored" });
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else if (res?.status === 501) {
				toast.error(res?.data?.message || "Payment method not found", { theme: "colored" });
			} else {
				toast.error(res?.data?.message || "Error deleting payment method", { theme: "colored" });
			}
		});
	},

	// Payment Bills
	getAllPaymentBills: () => (dispatch) => {
		dispatch({
			type: GET_ALL_PAYMENT_BILLS,
			payload: {
				getAllPaymentBillsLoading: true,
			},
		});
		getAllPaymentBills().then((res) => {
			dispatch({
				type: GET_ALL_PAYMENT_BILLS,
				payload: {
					getAllPaymentBillsLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: GET_ALL_PAYMENT_BILLS_SUCCESS,
					payload: {
						paymentBills: res?.data?.paymentBills || [],
					},
				});
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else {
				toast.error(res?.data?.message || "Error loading payment bills", { theme: "colored" });
			}
		});
	},

	getPaymentBill: (uuid) => (dispatch) => {
		dispatch({
			type: GET_PAYMENT_BILL,
			payload: {
				getPaymentBillLoading: true,
			},
		});
		getPaymentBill(uuid).then((res) => {
			dispatch({
				type: GET_PAYMENT_BILL,
				payload: {
					getPaymentBillLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: GET_PAYMENT_BILL_SUCCESS,
					payload: {
						paymentBill: res?.data?.paymentBill,
					},
				});
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else if (res?.status === 501) {
				toast.error(res?.data?.message || "Payment bill not found", { theme: "colored" });
			} else {
				toast.error(res?.data?.message || "Error loading payment bill", { theme: "colored" });
			}
		});
	},

	addPaymentBill: (data) => (dispatch) => {
		dispatch({
			type: ADD_PAYMENT_BILL,
			payload: {
				addPaymentBillLoading: true,
			},
		});
		return addPaymentBill(data).then((res) => {
			dispatch({
				type: ADD_PAYMENT_BILL,
				payload: {
					addPaymentBillLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: ADD_PAYMENT_BILL_SUCCESS,
					payload: {
						paymentBills: res?.data?.paymentBills || [],
					},
				});
				toast.success(res?.data?.message || "Payment bill added successfully", { theme: "colored" });
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else if (res?.status === 501) {
				toast.error(
					getPaymentBillErrorMessage(res, "Could not add payment bill"),
					{ theme: "colored" }
				);
			} else {
				toast.error(res?.data?.message || "Error adding payment bill", { theme: "colored" });
			}
			return res;
		});
	},

	updatePaymentBill: (data, uuid) => (dispatch) => {
		dispatch({
			type: UPDATE_PAYMENT_BILL,
			payload: {
				updatePaymentBillLoading: true,
			},
		});
		return updatePaymentBill(data, uuid).then((res) => {
			dispatch({
				type: UPDATE_PAYMENT_BILL,
				payload: {
					updatePaymentBillLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: UPDATE_PAYMENT_BILL_SUCCESS,
					payload: {
						paymentBills: res?.data?.paymentBills || [],
					},
				});
				toast.success(res?.data?.message || "Payment bill updated successfully", { theme: "colored" });
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else if (res?.status === 501) {
				toast.error(
					getPaymentBillErrorMessage(res, "Payment bill not found"),
					{ theme: "colored" }
				);
			} else {
				toast.error(res?.data?.message || "Error updating payment bill", { theme: "colored" });
			}
			return res;
		});
	},

	deletePaymentBill: (uuid) => (dispatch) => {
		dispatch({
			type: DELETE_PAYMENT_BILL,
			payload: {
				deletePaymentBillLoading: true,
			},
		});
		deletePaymentBill(uuid).then((res) => {
			dispatch({
				type: DELETE_PAYMENT_BILL,
				payload: {
					deletePaymentBillLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: DELETE_PAYMENT_BILL_SUCCESS,
					payload: {
						paymentBills: res?.data?.paymentBills || [],
					},
				});
				toast.success(res?.data?.message || "Payment bill deleted successfully", { theme: "colored" });
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else if (res?.status === 501) {
				toast.error(res?.data?.message || "Payment bill not found", { theme: "colored" });
			} else {
				toast.error(res?.data?.message || "Error deleting payment bill", { theme: "colored" });
			}
		});
	},

	// Void Reasons
	getAllVoidReasons: () => (dispatch) => {
		dispatch({
			type: GET_ALL_VOID_REASONS,
			payload: { getAllVoidReasonsLoading: true },
		});
		getAllVoidReasons().then((res) => {
			dispatch({
				type: GET_ALL_VOID_REASONS,
				payload: { getAllVoidReasonsLoading: false },
			});
			if (res?.status === 200) {
				dispatch({
					type: GET_ALL_VOID_REASONS_SUCCESS,
					payload: { voidReasons: res?.data?.voidReasons || [] },
				});
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else {
				toast.error(res?.data?.message || "Error loading void reasons", { theme: "colored" });
			}
		});
	},

	getVoidReason: (uuid) => (dispatch) => {
		dispatch({
			type: GET_VOID_REASON,
			payload: { getVoidReasonLoading: true },
		});
		getVoidReason(uuid).then((res) => {
			dispatch({
				type: GET_VOID_REASON,
				payload: { getVoidReasonLoading: false },
			});
			if (res?.status === 200) {
				dispatch({
					type: GET_VOID_REASON_SUCCESS,
					payload: { voidReason: res?.data?.voidReason },
				});
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else {
				toast.error(res?.data?.message || "Error loading void reason", { theme: "colored" });
			}
		});
	},

	addVoidReason: (data) => (dispatch) => {
		dispatch({
			type: ADD_VOID_REASON,
			payload: { addVoidReasonLoading: true },
		});
		return addVoidReason(data).then((res) => {
			dispatch({
				type: ADD_VOID_REASON,
				payload: { addVoidReasonLoading: false },
			});
			if (res?.status === 200) {
				dispatch({
					type: ADD_VOID_REASON_SUCCESS,
					payload: { voidReasons: res?.data?.voidReasons || [] },
				});
				toast.success(res?.data?.message || "Void reason added successfully", { theme: "colored" });
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else {
				toast.error(res?.data?.message || "Error adding void reason", { theme: "colored" });
			}
			return res;
		});
	},

	updateVoidReason: (data, uuid) => (dispatch) => {
		dispatch({
			type: UPDATE_VOID_REASON,
			payload: { updateVoidReasonLoading: true },
		});
		return updateVoidReason(data, uuid).then((res) => {
			dispatch({
				type: UPDATE_VOID_REASON,
				payload: { updateVoidReasonLoading: false },
			});
			if (res?.status === 200) {
				dispatch({
					type: UPDATE_VOID_REASON_SUCCESS,
					payload: { voidReasons: res?.data?.voidReasons || [] },
				});
				toast.success(res?.data?.message || "Void reason updated successfully", { theme: "colored" });
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else {
				toast.error(res?.data?.message || "Error updating void reason", { theme: "colored" });
			}
			return res;
		});
	},

	deleteVoidReason: (uuid) => (dispatch) => {
		dispatch({
			type: DELETE_VOID_REASON,
			payload: { deleteVoidReasonLoading: true },
		});
		deleteVoidReason(uuid).then((res) => {
			dispatch({
				type: DELETE_VOID_REASON,
				payload: { deleteVoidReasonLoading: false },
			});
			if (res?.status === 200) {
				dispatch({
					type: DELETE_VOID_REASON_SUCCESS,
					payload: { voidReasons: res?.data?.voidReasons || [] },
				});
				toast.success(res?.data?.message || "Void reason deleted successfully", { theme: "colored" });
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else {
				toast.error(res?.data?.message || "Error deleting void reason", { theme: "colored" });
			}
		});
	},

	// Refund Reasons
	getAllRefundReasons: () => (dispatch) => {
		dispatch({
			type: GET_ALL_REFUND_REASONS,
			payload: { getAllRefundReasonsLoading: true },
		});
		getAllRefundReasons().then((res) => {
			dispatch({
				type: GET_ALL_REFUND_REASONS,
				payload: { getAllRefundReasonsLoading: false },
			});
			if (res?.status === 200) {
				dispatch({
					type: GET_ALL_REFUND_REASONS_SUCCESS,
					payload: { refundReasons: res?.data?.refundReasons || [] },
				});
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else {
				toast.error(res?.data?.message || "Error loading refund reasons", { theme: "colored" });
			}
		});
	},

	getRefundReason: (uuid) => (dispatch) => {
		dispatch({
			type: GET_REFUND_REASON,
			payload: { getRefundReasonLoading: true },
		});
		getRefundReason(uuid).then((res) => {
			dispatch({
				type: GET_REFUND_REASON,
				payload: { getRefundReasonLoading: false },
			});
			if (res?.status === 200) {
				dispatch({
					type: GET_REFUND_REASON_SUCCESS,
					payload: { refundReason: res?.data?.refundReason },
				});
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else {
				toast.error(res?.data?.message || "Error loading refund reason", { theme: "colored" });
			}
		});
	},

	addRefundReason: (data) => (dispatch) => {
		dispatch({
			type: ADD_REFUND_REASON,
			payload: { addRefundReasonLoading: true },
		});
		return addRefundReason(data).then((res) => {
			dispatch({
				type: ADD_REFUND_REASON,
				payload: { addRefundReasonLoading: false },
			});
			if (res?.status === 200) {
				dispatch({
					type: ADD_REFUND_REASON_SUCCESS,
					payload: { refundReasons: res?.data?.refundReasons || [] },
				});
				toast.success(res?.data?.message || "Refund reason added successfully", { theme: "colored" });
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else {
				toast.error(res?.data?.message || "Error adding refund reason", { theme: "colored" });
			}
			return res;
		});
	},

	updateRefundReason: (data, uuid) => (dispatch) => {
		dispatch({
			type: UPDATE_REFUND_REASON,
			payload: { updateRefundReasonLoading: true },
		});
		return updateRefundReason(data, uuid).then((res) => {
			dispatch({
				type: UPDATE_REFUND_REASON,
				payload: { updateRefundReasonLoading: false },
			});
			if (res?.status === 200) {
				dispatch({
					type: UPDATE_REFUND_REASON_SUCCESS,
					payload: { refundReasons: res?.data?.refundReasons || [] },
				});
				toast.success(res?.data?.message || "Refund reason updated successfully", { theme: "colored" });
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else {
				toast.error(res?.data?.message || "Error updating refund reason", { theme: "colored" });
			}
			return res;
		});
	},

	deleteRefundReason: (uuid) => (dispatch) => {
		dispatch({
			type: DELETE_REFUND_REASON,
			payload: { deleteRefundReasonLoading: true },
		});
		deleteRefundReason(uuid).then((res) => {
			dispatch({
				type: DELETE_REFUND_REASON,
				payload: { deleteRefundReasonLoading: false },
			});
			if (res?.status === 200) {
				dispatch({
					type: DELETE_REFUND_REASON_SUCCESS,
					payload: { refundReasons: res?.data?.refundReasons || [] },
				});
				toast.success(res?.data?.message || "Refund reason deleted successfully", { theme: "colored" });
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else {
				toast.error(res?.data?.message || "Error deleting refund reason", { theme: "colored" });
			}
		});
	},
};

export default actions;

